import { QueryHookOptions } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { CampaignLabel } from 'modules/domains/campaign';
import { queryCampaignProjectLabels } from '../../../editor/queries';

type QueryCampaignProjectLabelsResponse = { campaignLabels: CampaignLabel[] };
type QueryCampaignProjectLabelsOptions = QueryHookOptions<QueryCampaignProjectLabelsResponse>;

export const useCampaignProjectLabels = () => {
  const queryOptions: QueryCampaignProjectLabelsOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
    }),
    [],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql<QueryCampaignProjectLabelsResponse>(queryCampaignProjectLabels, queryOptions);

  const results = data?.campaignLabels ?? [];

  return {
    errorMessage,
    hasError,
    isLoading,
    refetch,
    results,
  };
};
